import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import configureStore from './store';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ApiClient from './helpers/ApiClient';

const history = createBrowserHistory();
const client = new ApiClient(history);

ReactDOM.render(
    <Provider store={configureStore(history, client)}>
        <App history={history} />
    </Provider>
    , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
